export const environment = {
  production: true,
  apiUrl: 'https://apidev.pgwpay.com.br',
  appUrl: 'https://appdev.pgwpay.com.br',
  repoUrl: 'https://repodev.pgwpay.com.br',
  reCaptchaSite: '6LcSuswZAAAAAE4S6N-o8kr1l2cSRTb90YEAe01S',
  whitelistedDomains: ['apidev.pgwpay.com.br'],
  blacklistedRoutes: ['apidev.pgwpay.com.br/oauth/token', 'apidev.pgwpay.com.br/public/**']
};
